export default __webpack_public_path__ + "static/SelfApp_banner_mobile-6ad0c8b625a02d07729e2a4422407ae7.jpg";